import {redirect, useActionData, useRouteLoaderData} from "react-router-dom";
import FormDescription from "../../../components/Layout/FormDescription";
import FertilityPerformanceForm, {formDataToFertilityPerformance} from "./FertilityPerformanceForm";
import FormContainer from "../../../components/Layout/FormContainer";
import FertilityPerformances from "../../../services/UkTreatmentApi/FertilityPerformances";
import {useContext, useEffect} from "react";
import AlertContext from "../../../contexts/AlertContext";

export async function action({request, params}) {
    const formData = await request.formData();
    const fertilityPerformance = formDataToFertilityPerformance(formData);

    try {
        await FertilityPerformances.create(fertilityPerformance);

        return redirect(`/farms/${params.farmUid}/fertility_performances`);
    } catch (error) {
        return error;
    }
}

const Create = () => {
    const {handleErrorAlert} = useContext(AlertContext);
    const {farm} = useRouteLoaderData("currentFarm");
    const actionError = useActionData();

    useEffect(() => {
        if (actionError) handleErrorAlert(actionError, "Failed data submission")
    }, [actionError, handleErrorAlert]);

    return <FormContainer>
        <div className="md:col-span-1">
            <FormDescription title="Fertility Performance" text="Register the fertility performance in the app."/>
        </div>

        <div className="mt-5 md:col-span-3 md:mt-0">
            <FertilityPerformanceForm farm={farm} id="create-fertility-performance-form"/>
        </div>
    </FormContainer>;
}

export default Create;